import React, { Component } from 'react';
import { Formik } from 'formik';
import { Form, FormGroup, InputGroup, Input, Button, Label } from 'reactstrap';
import * as Yup from 'yup';
import './index.css';
import PostMan from '../utils/service';
import Cookies from 'js-cookie';
import GoogleLogin from './GoogleLogin';


const ValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Please enter your full name'),
  email: Yup.string()
    .email('Invalid email')
    .required('Please enter your e-mail'),
  password: Yup.string().required('Please enter a password'),
  confirmPassword: Yup.string()
    .required('Please enter a confirm password')
    .oneOf([Yup.ref('password'), null], 'The passwords you entered did not match.'),
  termsCheck: Yup.boolean().oneOf([true], 'Please accept terms & conditions.')
});

const FormFeedback = ({ valid, children }) => valid ? null : (
  <div className="formfeedback">
    {children}
  </div>
)

class SignupForm extends Component {

  state = {
    message: null,
    initialValues: {
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
      termsCheck: false,
      landingPage: Cookies.get('landingPage')
    }
  }

  responseGoogle = (response) => {
    console.log('response', response);
  }

  onSubmit = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    PostMan.register(values)
      .then(res => {
        values.email = ''
        values.name = ''
        values.password = ''
        values.confirmPassword = ''
        values.termsCheck = false
        this.setState({ message: "Please check email to activate your account" })
      })
      .catch((error) => {
        values.password = ''
        values.confirmPassword = ''
        this.setState({ message: error.response.data.message })
        // resetForm({})
      })
  }

  mapPropsToValues = (props) => {
    return this.state.initialValues;
  }

  render() {
    return (
      <div id="revue-embed" className="sign-up-join-modal">
        <Formik
          initialValues={this.state.initialValues}
          validationSchema={ValidationSchema}
          onSubmit={this.onSubmit}
          enableReinitialize={true}
        >
          {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched }) => (
            <Form onSubmit={handleSubmit} noValidate name='subscribeForm' id="subscribeForm" style={{ marginTop: 25 }}>
              <FormGroup>
                <InputGroup>
                <Input type="hidden"
                    name="landingPage"
                    id="landingPage"
                    autoFocus={false}
                    required
                    value={this.state.landingPage} />
                    
                  <Input type="text"
                    name="name"
                    id="name"
                    placeholder="Full Name"
                    autoFocus={false}
                    onChange={handleChange}
                    required
                    value={values.name} />
                  {/* <div className="input-group-append">
                    <span className="input-group-text"><i className="fa fa-user"></i></span>
                  </div> */}
                  <FormFeedback valid={(errors.name) ? false : true}>{errors.name}</FormFeedback>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup>
                  <Input type="email"
                    name="email"
                    id="email"
                    placeholder="Email Address"
                    autoFocus={false}
                    onChange={handleChange}
                    required
                    value={values.email} />
                  {/* <div className="input-group-append">
                    <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                  </div> */}
                  <FormFeedback valid={(errors.email) ? false : true}>{errors.email}</FormFeedback>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup>
                  <Input type="password"
                    name="password"
                    id="password"
                    placeholder="Password"
                    autoFocus={false}
                    onChange={handleChange}
                    required
                    value={values.password} />
                  <FormFeedback valid={(errors.password) ? false : true}>{errors.password}</FormFeedback>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup>
                  <Input type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    placeholder="Confirm Password"
                    autoFocus={false}
                    onChange={handleChange}
                    required
                    value={values.confirmPassword} />
                  <FormFeedback valid={(errors.confirmPassword) ? false : true}>{errors.confirmPassword}</FormFeedback>
                </InputGroup>
              </FormGroup>

              <FormGroup check>
                <InputGroup>

                  <Label check>
                    <Input type="checkbox"
                      name="termsCheck"
                      id="termsCheck"
                      onChange={handleChange}
                      defaultChecked={values.termsCheck}
                    />{' '}
                    I accept the Growjo's <a href="/terms" target='_blank'>Terms & Conditions</a>.
                  </Label>
                  <FormFeedback valid={(errors.termsCheck) ? false : true}>{errors.termsCheck}</FormFeedback>

                </InputGroup>
              </FormGroup>

              <FormGroup className="col-md-10 offset-3" style={{marginTop: '20px'}} >
                {this.props.modal ? <Button type="submit" color="success" className="mr-1" style={{ backgroundColor: 'red' }}>Download now!</Button> :
                  <react-fragment>
                    <Button type="submit" color="success" className="mr-1 join-btn col-md-6" style={{}}>Subscribe</Button>
                  </react-fragment>
                }
              </FormGroup>
              <div style={{ color: "red" }}>{this.state.message}</div>
            </Form>
          )}
        </Formik>

        <div className='col-md-7 offset-2 text-center'>
          OR <br /><br />
          <GoogleLogin />
        </div>





      </div>
    );
  }
}

export default SignupForm;



// WEBPACK FOOTER //
// ./client/src/components/signup.js